import {default as PageWrapper} from './PageWrapper';

export default PageWrapper;
